import { findRideApiService, FindRideApiService } from "./FindRideApiService";
import { buildLaterRidePayload } from "../utils/buildLaterRidePayload";
import { mapFindRideResponse } from "../utils/mapFindRideResponse";
import type {
  FindRideSearchCriteria,
  FindRideSearchResult,
} from "../types/findRide.types";

/**
 * Maps domain criteria ↔ API for Find Ride search and later-notify.
 */
export class FindRideRepository {
  constructor(private readonly api: FindRideApiService = findRideApiService) {}

  async search(
    criteria: FindRideSearchCriteria
  ): Promise<FindRideSearchResult> {
    const payload = await this.api.searchRides(criteria);
    return mapFindRideResponse(payload, criteria);
  }

  async saveLaterNotify(criteria: FindRideSearchCriteria): Promise<void> {
    const body = buildLaterRidePayload(criteria);
    await this.api.saveLaterRide(body);
  }
}

export const findRideRepository = new FindRideRepository();
